import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "navbar", "phones", "emails", "addresses", "websites" ]

  static values = {
    page: String,
    uuid: String,
    filter: String
  }

  connect() {
    if(this.hasNavbarTarget) {
      let navLink;
      if(this.filterValue == "") {
        navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
      } else if(this.filterValue == "shared") {
        navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
      } else if(this.filterValue == "projects") {
        navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
      }

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }
  }

  addPhone() {
    this.phonesTarget.innerHTML += `
      <div class="input-group mb-3">
        <select class="form-select" name="phones[][type]" style="max-width: 10rem;">
          <option value="mobile">${I18n.t('contact.mobile')}</option>
          <option value="home">${I18n.t('contact.home')}</option>
          <option value="work">${I18n.t('contact.work')}</option>
          <option value="home_mobile">${I18n.t('contact.home_mobile')}</option>
          <option value="work_mobile">${I18n.t('contact.work_mobile')}</option>
          <option value="fax">${I18n.t('contact.fax')}</option>
          <option value="home_fax">${I18n.t('contact.home_fax')}</option>
          <option value="work_fax">${I18n.t('contact.work_fax')}</option>
          <option value="other">${I18n.t('contact.other')}</option>
        </select>
        <input type="tel" class="form-control" name="phones[][value]" id="contactattr_phone">
        <button type="button" class="btn btn-outline-danger" type="button" data-action="click->contacts#removeItem">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    `
  }

  addEmail() {
    this.emailsTarget.innerHTML += `
      <div class="input-group mb-3">
        <select class="form-select" name="emails[][type]" style="max-width: 10rem;">
          <option value="home">${I18n.t('contact.home')}</option>
          <option value="work">${I18n.t('contact.work')}</option>
          <option value="other">${I18n.t('contact.other')}</option>
        </select>
        <input class="form-control" name="emails[][value]" type="email" id="contactattr_email">
        <button type="button" class="btn btn-outline-danger" type="button" data-action="click->contacts#removeItem">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    `
  }

  addAddress() {
    this.addressesTarget.innerHTML += `
      <div class="d-flex flex-column address mb-3">
        <div class="d-flex mb-1">
          <select class="form-select me-1" name="addresses[][type]">
            <option value="home" selected="">${I18n.t('contact.home')}</option>
            <option value="work">${I18n.t('contact.work')}</option>
            <option value="other">${I18n.t('contact.other')}</option>
          </select>
          <button type="button" class="btn btn-outline-danger ms-auto" data-action="click->contacts#removeAddress">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <input class="form-control mb-1" name="addresses[][street]" placeholder="Address" value="" type="text" id="contactattr_street">
        <div class="row mx-0">
          <div class="col-12 col-sm-3 mb-1 ps-0">
            <input class="form-control" name="addresses[][zip]" placeholder="ZIP" value="" type="text" id="contactattr_zip">
          </div>
          <div class="col-12 col-sm-9 mb-1 px-0">
            <input class="form-control" name="addresses[][city]" placeholder="City" type="text" id="contactattr_city">
          </div>
        </div>
        <input class="form-control mb-1" name="addresses[][state]" placeholder="State" value="" type="text" id="contactattr_state">
        <input class="form-control mb-1" name="addresses[][country]" placeholder="Country" value="" type="text" id="contactattr_country">
      </div>
    `
  }

  addWebsite() {
    this.websitesTarget.innerHTML += `
      <div class="input-group mb-3">
        <select class="form-select" name="websites[][type]" style="max-width: 10rem;">
          <option value="home" selected="">${I18n.t('contact.home')}</option>
          <option value="work">${I18n.t('contact.work')}</option>
          <option value="other">${I18n.t('contact.other')}</option>
        </select>
        <input type="url" class="form-control" name="websites[][value]" id="contactattr_website">
        <button type="button" class="btn btn-outline-danger" type="button" data-action="click->contacts#removeItem">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    `
  }

  removeItem() {
    let el = event.target.closest('div.input-group');
    if(el) {
      el.remove()
    }
  }

  removeAddress() {
    let el = event.target.closest('div.address');
    if(el) {
      el.remove()
    }
  }
}
